import React, { useCallback, useEffect, useState } from 'react';

import { Container, Star } from './styles';

interface Props {
  categories: { text: string; count: number }[];
  values: string[];
  onChange: (values: string[]) => void;
  onOptionChange?: (value: string, isChecked: boolean) => void;
}

const Stars = ({ categories, values, onChange, onOptionChange }: Props) => {
  const isActive = useCallback((checkValue: string) => Boolean(values.find((item) => item === checkValue)), [values]);

  const handleClick = (newValue: string) => {
    if (isActive(newValue)) {
      onChange(values.filter((item) => item !== newValue));
    } else {
      onChange([...values, newValue]);
    }
    if (onOptionChange) onOptionChange(newValue, !isActive(newValue));
  };

  const [hasSingleChild, setHasSingleChild] = useState(false);

  useEffect(() => {
    const container = document.getElementById('stars-container');
    if (container) {
      setHasSingleChild(container.childElementCount === 1);
    }
  }, [categories]);

  return (
    <Container id="stars-container" hasSingleChild={hasSingleChild}>
      {categories.map((category) => (
        <Star
          key={category.text}
          className={isActive(category.text) ? 'active' : ''}
          onClick={() => handleClick(category.text)}
        >
          {category.text}
        </Star>
      ))}
    </Container>
  );
};

export default Stars;
